import { __read } from "tslib";
import React from 'react';
export var FlyoutContext = React.createContext({
    launchOptions: {
        emptyStateMessage: '',
        launchTileBehavior: '',
        searchDebounceRate: 0,
    },
    userSearchQuery: '',
    setUserSearchQuery: function () { return undefined; },
});
export var useFlyoutContext = function () { return React.useContext(FlyoutContext); };
export var FlyoutContextProvider = function (_a) {
    var children = _a.children, launchOptions = _a.launchOptions;
    var _b = __read(React.useState(''), 2), userSearchQuery = _b[0], setUserSearchQuery = _b[1];
    var context = useMemoContext({
        launchOptions: launchOptions,
        userSearchQuery: userSearchQuery,
        setUserSearchQuery: setUserSearchQuery,
    });
    return (React.createElement(FlyoutContext.Provider, { value: context }, children));
};
var useMemoContext = function (_a) {
    var launchOptions = _a.launchOptions, userSearchQuery = _a.userSearchQuery, setUserSearchQuery = _a.setUserSearchQuery;
    return React.useMemo(function () { return ({
        launchOptions: launchOptions,
        userSearchQuery: userSearchQuery,
        setUserSearchQuery: setUserSearchQuery,
    }); }, [launchOptions, userSearchQuery, setUserSearchQuery]);
};
//# sourceMappingURL=FlyoutContext.js.map